import HitItem from '../HitItem'
import { Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'

interface BankOutOfConnectionFraudProps {
  data: any
}

export default function BankOutOfConnectionFraud({ data }: BankOutOfConnectionFraudProps) {
  const theme = useTheme()

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        银行失联欺诈
      </Text>
      <Stack gap="sm" className="mt-3">
        <HitItem
          name={'银行失联欺诈'}
          hitCount={data?.als_yhslqz_count || 0}
          recentHitTime={data?.als_yhslqz_count === 0 ? '-' : `近${(data?.als_yhslqz_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'银行90天以内异常'}
          hitCount={data?.als_d90_yq_count || 0}
          recentHitTime={data?.als_d90_yq_count === 0 ? '-' : `近${(data?.als_d90_yq_duration ?? 0) + 1}年内`}
        />
        <HitItem
          name={'银行90天以上异常'}
          hitCount={data?.als_gt_d90_yq_count || 0}
          recentHitTime={data?.als_gt_d90_yq_count === 0 ? '-' : `近${(data?.als_gt_d90_yq_duration ?? 0) + 1}年内`}
        />
      </Stack>
    </div>
  )
}
